import React from 'react';
import { Stack } from '@mui/material';
import { useMutation, useQuery } from '@apollo/client';
import {
  GET_MY_ACCESS_TOKENS_QUERY,
  REMOVE_ACCESS_TOKEN_MUTATION,
} from '../../gql';
import { AccessTokenGrid } from './AccessTokenGrid';
import { FormattedMessage } from 'react-intl';

const containerStyles = { maxWidth: 640, flexGrow: 1 };

const AccessTokenSettings = React.memo(() => {
  const { data: accessTokensData, loading } = useQuery(
    GET_MY_ACCESS_TOKENS_QUERY,
    {
      fetchPolicy: 'cache-first',
    }
  );

  const [removeAccessToken] = useMutation(REMOVE_ACCESS_TOKEN_MUTATION, {
    refetchQueries: [{ query: GET_MY_ACCESS_TOKENS_QUERY }],
  });

  if (loading || !accessTokensData) {
    return (
      <div>
        <FormattedMessage id="general.loading" defaultMessage="Loading…" />
      </div>
    );
  }

  const accessTokens = accessTokensData.getMyAccessTokens;

  return (
    <Stack gap={2} sx={containerStyles}>
      <AccessTokenGrid data={accessTokens} onRemove={removeAccessToken} />
    </Stack>
  );
});

export { AccessTokenSettings };
